let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2U8zg")).then(() => parcelRequire('f9wiC'));